import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthState } from '../hooks/useAuthState';
import { collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { getEvent } from '../lib/firestore/events';
import { getGroup } from '../lib/firestore/groups';
import { createRSVP } from '../lib/firestore/events';
import { addGroupMember } from '../lib/firestore/groups';
import '../styles/InvitesInbox.css';

const InvitesInbox = () => {
  const { user } = useAuthState();
  const navigate = useNavigate();

  const [invites, setInvites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      loadInvites();
    } else {
      navigate('/login');
    }
  }, [user, navigate]);

  const loadInvites = async () => {
    if (!user) return;

    setLoading(true);
    try {
      // Load event invites where user is target
      const eventInvitesQuery = query(
        collection(db, 'events'),
      );
      
      // This is simplified - in production would query event invites subcollection
      // For now, we'll show a message
      setInvites([]);
    } catch (error) {
      console.error('Error loading invites:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAcceptInvite = async (invite) => {
    try {
      if (invite.target.kind === 'event_join') {
        await createRSVP({
          userId: user.uid,
          eventId: invite.target.id,
          state: 'going',
          plusOnes: 0,
        });
        navigate(`/events/${invite.target.id}`);
      } else if (invite.target.kind === 'group_join') {
        await addGroupMember(invite.target.id, {
          userId: user.uid,
          role: invite.metadata?.role || 'member',
          sponsoredBy: invite.metadata?.sponsorId,
          joinedAt: new Date(),
        });
        navigate(`/groups/${invite.target.id}`);
      }
    } catch (error) {
      alert('Failed to accept invite: ' + error.message);
    }
  };

  const handleDeclineInvite = async (inviteId) => {
    try {
      // In production, would update invite status to 'declined'
      await loadInvites();
    } catch (error) {
      console.error('Error declining invite:', error);
    }
  };

  if (loading) {
    return (
      <div className="invites-inbox-container">
        <div className="loading">Loading invites...</div>
      </div>
    );
  }

  return (
    <div className="invites-inbox-container">
      <header className="inbox-header">
        <h1>Invites</h1>
        <button className="btn btn-secondary" onClick={() => navigate('/home')}>
          Back to Home
        </button>
      </header>

      <main className="inbox-main">
        {invites.length === 0 ? (
          <div className="empty-inbox">
            <p>No pending invites</p>
            <p className="empty-hint">
              When someone invites you to a group or event, it will appear here.
            </p>
          </div>
        ) : (
          <div className="invites-list">
            {invites.map((invite) => (
              <div key={invite.id} className="invite-card">
                <div className="invite-content">
                  <h3>
                    {invite.target.kind === 'event_join' && 'Event Invitation'}
                    {invite.target.kind === 'group_join' && 'Group Invitation'}
                    {invite.target.kind === 'profile_follow' && 'Follow Request'}
                  </h3>
                  {invite.metadata?.sponsorId && (
                    <p className="sponsor-notice">
                      You've been sponsored to join
                    </p>
                  )}
                </div>
                <div className="invite-actions">
                  <button
                    className="btn btn-primary"
                    onClick={() => handleAcceptInvite(invite)}
                  >
                    Accept
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => handleDeclineInvite(invite.id)}
                  >
                    Decline
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default InvitesInbox;




